export const PRINTER_TYPE = {
    EPSON: 'epson',
    SUNMI: 'sunmi',
    BIXOLON: 'bixolon',
    CLOUDPRINT: 'cloudprint',
    WEBPRINT: 'WEBPRNT',
    QZ: 'QZ'
};

export const NATIVE_APP_PRINTER_TYPES = [
    PRINTER_TYPE.EPSON,
    PRINTER_TYPE.SUNMI,
    PRINTER_TYPE.BIXOLON,
];